import moment from 'moment'
moment.locale('zh-cn')
let utils = {
  timeStr (time) {
    let date = moment(time).format('YYYY-M-D')
    let today = moment().format('YYYY-M-D')
    let currentYear = moment().format('YYYY')
    let year = moment(time).format('YYYY')
    let yesterDay = moment().subtract(1, 'day').format('YYYY-M-D')

    if (+new Date() - time < 3600 * 1000) {
      return moment(time).fromNow()
    } else if (date === today) {
      return moment(time).format('HH:mm')
    } else if (date === yesterDay) {
      return '昨天 ' + moment(time).format('HH:mm')
    } else if (year === currentYear) {
      return moment(time).format('M月D日 HH:mm')
    } else {
      return moment(time).format('YYYY年M月D日 HH:mm')
    }
  },
  isSameDate: (date1, date2) => {
    return utils.isSameMonth(date1, date2) &&
      moment(date1).date() == moment(date2).date()
  },
  isSameMonth: (date1, date2) => {
    return utils.isSameYear(date1, date2) && moment(date1).month() == moment(date2).month()
  },
  isSameYear: (date1, date2) => { return moment(date1).year() == moment(date2).year() }

}

export default utils



// WEBPACK FOOTER //
// ./src/mods/dateutil.js